<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="订单编号">
                  <el-input style="width: 200px" v-model="queryForm.orderNumber"></el-input>
              </el-form-item>
              <el-form-item label="门店">
<!--                  <el-input  v-model="queryForm.storeId"></el-input>-->
                  <GridSelectLi
                      style="width: 200px"
                      title="选择门店"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      placeholder="请选择门店"
                      @getValue="getSearchValueStoreId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectLi>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 200px" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="支付类型">
                  <el-select
                      placeholder="请选择活动类型"
                      clearable
                      style='width: 200px'
                      size="small"
                      v-model="queryForm.payType"
                  >
                      <el-option
                          v-for='(item,index) in payTypeList'
                          :key='index'
                          :label="item.value"
                          :value="item.key"
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="付款时间">
                  <el-date-picker
                      v-model="paytimeRange"
                      style="width: 200px"
                      type="datetimerange"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      @change="handleDateChange"
                      >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="订单状态">
                  <el-select
                      placeholder="请选择订单状态"
                      clearable
                      style='width: 200px'
                      size="small"
                      v-model="queryForm.orderStatus"
                  >
                      <el-option label="已取消" :value="0" />
                      <el-option label="待支付" :value="1" />
                      <el-option label="已支付" :value="2" />
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopStorePayOrder"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopStorePayOrder(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStorePayOrder(null)"
        >删除</el-button>

          <span class="count">订单总额：{{countObj.money1Count}}</span>
          <span class="count">用券总抵：{{countObj.money2Count}}</span>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopStorePayOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStorePayOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="userId"
            label="用户"
            width="180"
        >
            <template slot-scope="scope">
                <div v-if="scope.row.user">
                    <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                    <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                    <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                    <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                </div>
                <div v-else>--</div>
            </template>
        </el-table-column>
<!--        <el-table-column-->
<!--            :show-overflow-tooltip="true"-->
<!--            align="center"-->
<!--            prop="orderContact"-->
<!--            label="收件信息"-->
<!--            width="180"-->
<!--        >-->
<!--            <template slot-scope="scope">-->
<!--                <div style="text-align: left">收货姓名：{{ scope.row.orderContact }}</div>-->
<!--                <div style="text-align: left">收货电话：{{ scope.row.orderTel }}</div>-->
<!--                <div style="text-align: left">下单备注：{{ scope.row.orderRemarks }}</div>-->
<!--            </template>-->
<!--        </el-table-column>-->
        <el-table-column :show-overflow-tooltip="true" align="left" label="订单信息" width="200">
            <template slot-scope="scope">
                <div style="text-align: left">订单编号：{{ scope.row.orderNumber }}</div>
                <div style="text-align: left">下单时间：{{ scope.row.orderAddtime }}</div>
                <div style="text-align: left" v-if="scope.row.orderPaytime">支付时间：{{ scope.row.orderPaytime }}</div>
                <div style="text-align: left" v-if="scope.row.orderCanceltime">取消时间：{{ scope.row.orderCanceltime }}</div>
                <div style="text-align: left" v-if="scope.row.orderFinishtime">完成时间：{{ scope.row.orderFinishtime }}</div>
                <div style="text-align: left" v-if="scope.row.orderDeletetime">删除时间：{{ scope.row.orderDeletetime }}</div>
            </template>
        </el-table-column>
<!--        <el-table-column-->
<!--            :show-overflow-tooltip="true"-->
<!--            align="center"-->
<!--            prop="giveUserScore"-->
<!--            label="积分信息"-->
<!--            width="180"-->
<!--        >-->
<!--            <template slot-scope="scope">-->
<!--                <div style="text-align: left">用户贡献值：{{ scope.row.giveUserScore }}</div>-->
<!--                <div style="text-align: left">商家贡献值：{{ scope.row.giveStoreScore }}</div>-->
<!--                <div style="text-align: left" v-if="scope.row.serviceType == 5">商家悦果：{{ scope.row.giveStoreScore1 }}</div>-->
<!--                <div style="text-align: left" v-else>商家悦豆：{{ scope.row.giveStoreScore1 }}</div>-->
<!--            </template>-->
<!--        </el-table-column>-->
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="giveUserScore"
            label="用户积分"
            width="180"
        >
            <template slot-scope="scope">
                <div style="text-align: left">消费凭证：{{ scope.row.userMoney1 }}</div>
                <div style="text-align: left">贡献值：{{ scope.row.userMoney2 }}</div>
                <div style="text-align: left">消费券额度：{{ scope.row.userMoney3 }}</div>
                <div style="text-align: left">动券宝额度：{{ scope.row.userMoney4 }}</div>
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="giveUserScore"
            label="门店积分"
            width="180"
        >
            <template slot-scope="scope">
                <div style="text-align: left">消费凭证：{{ scope.row.storeMoney1 }}</div>
                <div style="text-align: left">贡献值：{{ scope.row.storeMoney2 }}</div>
                <div style="text-align: left">消费券额度：{{ scope.row.storeMoney3 }}</div>
                <div style="text-align: left">动券宝额度：{{ scope.row.storeMoney4 }}</div>
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="serviceFee"
            label="服务信息"
            width="180"
        >
            <template slot-scope="scope">
                <div style="text-align: left">服务费类型：{{ scope.row.serviceType }}</div>
                <div style="text-align: left">服务费比例：{{ scope.row.serviceRatio }}</div>
                <div style="text-align: left">服务费：{{ scope.row.serviceFee }}</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单总价"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="actualPrice"
        label="订单实付金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="discountUserMoney"
        label="用券抵扣"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="所属门店"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.store">{{ scope.row.store.storeName }}</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderStatus"
        label="订单状态"
        width="180"
      >
          <template slot-scope="scope">
              {{getOrderLabel(scope.row.orderStatus)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payType"
        label="支付类型"
        width="180"
      >
          <template slot-scope="scope">
              <el-tag type="danger" effect="light" v-if='scope.row.payType'>{{ getPayTypeLabel(scope.row.payType) }}</el-tag>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payNo"
        label="外部交易号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payId"
        label="统一支付ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currencyType"
        label="货币类型"
        width="180"
      >
          <template slot-scope="scope">
              <div>{{ getProductTypeLabel(scope.row.currencyType) }}</div>
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStorePayOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopStorePayOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopStorePayOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStorePayOrderStates[shopStorePayOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStorePayOrder"
          ref="shopStorePayOrderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="订单总价"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderPrice"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单实付金额"
            prop="actualPrice"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.actualPrice"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="抵扣积分"
            prop="orderScore"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderScore"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户贡献值"
            prop="giveUserScore"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.giveUserScore"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商家贡献值"
            prop="giveStoreScore"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.giveStoreScore"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商家悦豆悦果"
            prop="giveStoreScore1"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.giveStoreScore1"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="服务费"
            prop="serviceFee"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.serviceFee"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="服务费类型"
            prop="serviceType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="shopStorePayOrder.serviceType"-->
<!--              :disabled="shopStorePayOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择签约服务费类型'
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='shopStorePayOrder.serviceType'
                  :disabled="shopStorePayOrderState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in serviveTypeList'
                      :key='index'
                      :label='item.value'
                      :value='item.key'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="服务费比例"
            prop="serviceRatio"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.serviceRatio"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单编号"
            prop="orderNumber"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderNumber"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="收件姓名"
            prop="orderContact"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderContact"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="orderTel"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderTel"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="下单留言"
            prop="orderRemarks"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderRemarks"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="门店"
            prop="storeId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStorePayOrder.storeId"-->
<!--              :disabled="shopStorePayOrderState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectLi
                  style="width: 177px"
                  title="选择门店"
                  labelName="storeName"
                  labelValue="id"
                  :value="shopStorePayOrder.storeId"
                  :disabled="shopStorePayOrderState == 'check'"
                  :limit="1"
                  size="small"
                  placeholder="请选择门店"
                  @getValue="getValueStoreId"
                  :columns="STORE_code"
                  :searchs="STORE_search"
                  dataListUrl="/shop/store/findList"
                  entityBeanName="shopStore"
                  queryEntityUrl="/shop/store/get"
              >
              </GridSelectLi>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStorePayOrder.userId"-->
<!--              :disabled="shopStorePayOrderState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="shopStorePayOrder.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="shopStorePayOrderState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="取消时间"
            prop="orderCanceltime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderCanceltime"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="下单时间"
            prop="orderAddtime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderAddtime"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付时间"
            prop="orderPaytime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderPaytime"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="完成时间"
            prop="orderFinishtime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderFinishtime"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="删除时间"
            prop="orderDeletetime"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.orderDeletetime"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单状态"
            prop="orderStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="shopStorePayOrder.orderStatus"-->
<!--              :disabled="shopStorePayOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 177px"
                  size="small"
                  v-model="shopStorePayOrder.orderStatus"
                  :disabled="shopStorePayOrderState == 'check'"
              >
                  <el-option v-for="item in orderStatusList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="支付类型"
            prop="payType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="shopStorePayOrder.payType"-->
<!--              :disabled="shopStorePayOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 177px"
                  size="small"
                  v-model="shopStorePayOrder.payType"
                  :disabled="shopStorePayOrderState == 'check'"
              >
                  <el-option v-for="item in payTypeList " :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="外部交易号"
            prop="payNo"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.payNo"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="统一支付ID"
            prop="payId"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStorePayOrder.payId"
              :disabled="shopStorePayOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="货币类型"
            prop="currencyType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="shopStorePayOrder.currencyType"-->
<!--              :disabled="shopStorePayOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 177px"
                  size="small"
                  v-model="shopStorePayOrder.currencyType"
                  :disabled="shopStorePayOrderState == 'check'"
              >
                  <el-option v-for="item in currencyList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStorePayOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH, USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStorePayOrderList();
                    this.getShopStorePayOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStorePayOrderList();
                    this.getShopStorePayOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                  orderStatus: null, //订单状态
                     orderPrice: '', //订单总价
                     actualPrice: '', //订单实付金额
                     orderScore: '', //抵扣积分
                     giveUserScore: '', //赠送给用户贡献值数量
                     giveStoreScore: '', //赠送给商家贡献值数量
                     giveStoreScore1: '', //赠送给商家悦豆或悦果数量
                     serviceFee: '', //服务费
                     serviceType: '', //服务费类型
                     serviceRatio: '', //服务费比例
                     orderNumber: '', //订单编号
                     orderContact: '', //收件姓名
                     orderTel: '', //联系电话
                     orderRemarks: '', //订单备注、下单留言
                     storeId: '', //门店ID
                     userId: '', //用户ID
                     orderCanceltime: '', //取消时间
                     orderAddtime: '', //下单时间
                     orderPaytime: '', //支付时间
                     orderFinishtime: '', //完成时间-完成的订单无法售后
                     orderDeletetime: '', //删除时间
                     orderStatus: '', //订单状态
                     payType: '', //支付类型
                     payNo: '', //外部交易号
                     payId: '', //统一支付的一批订单，需要有同一个ID
                     currencyType: '', //货币类型
                    startPayTime: '',
                    endPayTime: ''
                },
                paytimeRange: [],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStorePayOrderState: 'add',
                shopStorePayOrderStates: {
                    add: '新建付款订单',
                    check: '查看付款订单',
                    edit: '修改付款订单'
                },
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                shopStorePayOrderList: [],
                shopStorePayOrder: {
                    id: '', //ID
                    orderPrice: '', //订单总价
                    actualPrice: '', //订单实付金额
                    orderScore: '', //抵扣积分
                    giveUserScore: '', //赠送给用户贡献值数量
                    giveStoreScore: '', //赠送给商家贡献值数量
                    giveStoreScore1: '', //赠送给商家悦豆或悦果数量
                    serviceFee: '', //服务费
                    serviceType: '', //服务费类型
                    serviceRatio: '', //服务费比例
                    orderNumber: '', //订单编号
                    orderContact: '', //收件姓名
                    orderTel: '', //联系电话
                    orderRemarks: '', //订单备注、下单留言
                    storeId: '', //门店ID
                    userId: '', //用户ID
                    orderCanceltime: '', //取消时间
                    orderAddtime: '', //下单时间
                    orderPaytime: '', //支付时间
                    orderFinishtime: '', //完成时间-完成的订单无法售后
                    orderDeletetime: '', //删除时间
                    orderStatus: '', //订单状态
                    payType: '', //支付类型
                    payNo: '', //外部交易号
                    payId: '', //统一支付的一批订单，需要有同一个ID
                    currencyType: '', //货币类型
                },
                btnLoading: false,

                rules: {
                    orderPrice: [{ required: true, message: '订单总价不能为空', trigger: 'blur' }],
                    actualPrice: [{ required: true, message: '订单实付金额不能为空', trigger: 'blur' }],
                    orderScore: [{ required: true, message: '抵扣积分不能为空', trigger: 'blur' }],
                    giveUserScore: [{ required: true, message: '赠送给用户贡献值数量不能为空', trigger: 'blur' }],
                    giveStoreScore: [{ required: true, message: '赠送给商家贡献值数量不能为空', trigger: 'blur' }],
                    giveStoreScore1: [{ required: true, message: '赠送给商家悦豆或悦果数量不能为空', trigger: 'blur' }],
                    serviceFee: [{ required: true, message: '服务费不能为空', trigger: 'blur' }],
                    serviceType: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                    serviceRatio: [{ required: true, message: '服务费比例不能为空', trigger: 'blur' }],
                    orderNumber: [{ required: true, message: '订单编号不能为空', trigger: 'blur' }],
                    orderContact: [{ required: true, message: '收件姓名不能为空', trigger: 'blur' }],
                    orderTel: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                    orderRemarks: [{ required: true, message: '订单备注、下单留言不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    orderCanceltime: [{ required: true, message: '取消时间不能为空', trigger: 'blur' }],
                    orderAddtime: [{ required: true, message: '下单时间不能为空', trigger: 'blur' }],
                    orderPaytime: [{ required: true, message: '支付时间不能为空', trigger: 'blur' }],
                    orderFinishtime: [{ required: true, message: '完成时间-完成的订单无法售后不能为空', trigger: 'blur' }],
                    orderDeletetime: [{ required: true, message: '删除时间不能为空', trigger: 'blur' }],
                    orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                    payType: [{ required: true, message: '支付类型不能为空', trigger: 'blur' }],
                    payNo: [{ required: true, message: '外部交易号不能为空', trigger: 'blur' }],
                    payId: [{ required: true, message: '统一支付的一批订单，需要有同一个ID不能为空', trigger: 'blur' }],
                    currencyType: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
                },
                payTypeList: [],
                currencyList: [],
                serviveTypeList: [],
                orderStatusList: [], //订单状态
                countObj: {
                    money1Count: 0,
                    money2Count: 0
                }
            };
        },
        created() {
           this.getTodayTimeRange()
            this.getProductType();
            this.getShopStorePayOrderList();
            this.getPayType();

        },
        methods: {
          handleDateChange(val) {
                if (val && val.length > 0) {
                    this.queryForm.startPayTime = val[0];
                    this.queryForm.endPayTime = val[1];
                } else {
                    this.queryForm.startPayTime = '';
                    this.queryForm.endPayTime = '';
                  }
                  this.getShopStorePayOrderList();
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            // 获取枚举
            getProductType(){
                get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                    if (res.success) {
                        this.currencyList = res.enumList;
                    }
                });
                get('/shop/utils/getEnum', { enumType: 'store_service_type' }).then((res) => {
                    if (res.success && res.code == 200) {
                        this.serviveTypeList = res.enumList;
                    }
                });
                get('/shop/utils/getEnum', { enumType: 'store_pay_order_status' }).then((data) => {
                    if (data.success) {
                        this.orderStatusList = data.enumList;
                        // console.log(this.orderStatusList);
                    }
                });
            },
            //根据订单状态值找标签
            getOrderLabel(orderStatus) {
                for (const index in this.orderStatusList) {
                    if (this.orderStatusList[index].key == orderStatus) {
                        return this.orderStatusList[index].value;
                    }
                }
            },
            //根据服务方式值找标签
            getServiveTypeLabel(payType) {
                for (const index in this.serviveTypeList) {
                    if (this.serviveTypeList[index].key === payType) {
                        //console.log(this.payTypeList[index].value);
                        return this.serviveTypeList[index].value;
                    }
                }
            },
            //根据货币方式值找标签
            getProductTypeLabel(payType) {
                for (const index in this.currencyList) {
                    if (this.currencyList[index].key === payType) {
                        //console.log(this.payTypeList[index].value);
                        return this.currencyList[index].value;
                    }
                }
            },
            resetShopStorePayOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStorePayOrderList = [];
            },
            //获取支付方式
            getPayType() {
                get('/mpp/utils/getEnum', { enumType: 'order_pay_type' }).then((data) => {
                    if (data.success) {
                        this.payTypeList = data.enumList;
                    }
                });
            },
            //根据支付方式值找标签
            getPayTypeLabel(payType) {
                for (const index in this.payTypeList) {
                    if (this.payTypeList[index].key === payType) {
                        //console.log(this.payTypeList[index].value);
                        return this.payTypeList[index].value;
                    }
                }
            },
            resetDialog() {
                this.shopStorePayOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      orderPrice: '', //订单总价
                      actualPrice: '', //订单实付金额
                      orderScore: '', //抵扣积分
                      giveUserScore: '', //赠送给用户贡献值数量
                      giveStoreScore: '', //赠送给商家贡献值数量
                      giveStoreScore1: '', //赠送给商家悦豆或悦果数量
                      serviceFee: '', //服务费
                      serviceType: '', //服务费类型
                      serviceRatio: '', //服务费比例
                      orderNumber: '', //订单编号
                      orderContact: '', //收件姓名
                      orderTel: '', //联系电话
                      orderRemarks: '', //订单备注、下单留言
                      storeId: '', //门店ID
                      userId: '', //用户ID
                      orderCanceltime: '', //取消时间
                      orderAddtime: '', //下单时间
                      orderPaytime: '', //支付时间
                      orderFinishtime: '', //完成时间-完成的订单无法售后
                      orderDeletetime: '', //删除时间
                      orderStatus: '', //订单状态
                      payType: '', //支付类型
                      payNo: '', //外部交易号
                      payId: '', //统一支付的一批订单，需要有同一个ID
                      currencyType: '', //货币类型
                };
                this.getShopStorePayOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStorePayOrder = {
                      id: '', //ID
                      orderPrice: '', //订单总价
                      actualPrice: '', //订单实付金额
                      orderScore: '', //抵扣积分
                      giveUserScore: '', //赠送给用户贡献值数量
                      giveStoreScore: '', //赠送给商家贡献值数量
                      giveStoreScore1: '', //赠送给商家悦豆或悦果数量
                      serviceFee: '', //服务费
                      serviceType: '', //服务费类型
                      serviceRatio: '', //服务费比例
                      orderNumber: '', //订单编号
                      orderContact: '', //收件姓名
                      orderTel: '', //联系电话
                      orderRemarks: '', //订单备注、下单留言
                      storeId: '', //门店ID
                      userId: '', //用户ID
                      orderCanceltime: '', //取消时间
                      orderAddtime: '', //下单时间
                      orderPaytime: '', //支付时间
                      orderFinishtime: '', //完成时间-完成的订单无法售后
                      orderDeletetime: '', //删除时间
                      orderStatus: '', //订单状态
                      payType: '', //支付类型
                      payNo: '', //外部交易号
                      payId: '', //统一支付的一批订单，需要有同一个ID
                      currencyType: '', //货币类型
                };
            },
            submitForm() {
                if (this.shopStorePayOrderState == 'add') {
                    this.$refs.shopStorePayOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storepayorder/add`,{ ...this.shopStorePayOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStorePayOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStorePayOrderState == 'edit') {
                    this.$refs.shopStorePayOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            let params = this.shopStorePayOrder
                            delete params.user;
                            delete params.store;
                            post(`/shop/storepayorder/edit`,{ ...params }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStorePayOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStorePayOrder() {
                this.showDialog = true;
                this.shopStorePayOrderState = 'add';
            },
            getValueUser(value){
                this.shopStorePayOrder.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            getValueStoreId(value){
                this.shopStorePayOrder.storeId = value
            },
            getSearchValueStoreId(value){
                this.queryForm.storeId = value
            },
            checkShopStorePayOrder(shopStorePayOrderId) {
                console.log(shopStorePayOrderId);
                this.currentShopStorePayOrderId = shopStorePayOrderId;

                this.getShopStorePayOrderById();
                this.showDialog = true;
                this.shopStorePayOrderState = 'check';
            },
            editShopStorePayOrder(shopStorePayOrderId) {
                console.log('shopStorePayOrder', shopStorePayOrderId);
                if (shopStorePayOrderId) {
                    this.currentShopStorePayOrderId = shopStorePayOrderId;
                    this.getShopStorePayOrderById();
                } else {
                    this.shopStorePayOrder = { ...this.shopStorePayOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStorePayOrderState = 'edit';
            },
            deleteShopStorePayOrder(shopStorePayOrderId) {
                let ids = '';
                if (shopStorePayOrderId) {
                    ids = shopStorePayOrderId;
                } else {
                    ids = this.multipleSelection.map((shopStorePayOrder) => shopStorePayOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storepayorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayOrderList();
                                this.getShopStorePayOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStorePayOrderList() {
                this.resetShopStorePayOrderList();
                this.getShopStorePayOrderList();
            },
            // 获取当天开始和结束时间
             getTodayTimeRange() {
                    const now = new Date();
                    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
                    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

                    const formatDate = (date) => {
                        const y = date.getFullYear();
                        const m = String(date.getMonth() + 1).padStart(2, '0');
                        const d = String(date.getDate()).padStart(2, '0');
                        const h = String(date.getHours()).padStart(2, '0');
                        const min = String(date.getMinutes()).padStart(2, '0');
                        const s = String(date.getSeconds()).padStart(2, '0');
                        return `${y}-${m}-${d} ${h}:${min}:${s}`;
                    };

                    this.queryForm.startPayTime = formatDate(startOfDay);
                    this.queryForm.endPayTime = formatDate(endOfDay);
                    this.paytimeRange = [formatDate(startOfDay), formatDate(endOfDay)];
                },
            getShopStorePayOrderList(query = {}) {
                this.loading = true;
                
                if (this.paytimeRange != null) {
                    this.queryForm.startPayTime = this.paytimeRange[0];
                    this.queryForm.endPayTime = this.paytimeRange[1];
                }else{
                    this.queryForm.startPayTime = '';
                    this.queryForm.endPayTime = '';
                }
                get(`/shop/storepayorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStorePayOrderList = res.page.list;
                        this.totalNum = res.page.total;
                        if(res.moneyCounts){
                            this.countObj = res.moneyCounts;
                        }else{
                            this.countObj= {
                                money1Count: 0,
                                money2Count: 0
                            }
                        }
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStorePayOrderById() {
                get(`/shop/storepayorder/get`,{ id: this.currentShopStorePayOrderId }).then((res) =>{
                    if(res.success){
                      this.shopStorePayOrder = { ...this.shopStorePayOrder, ...res.shopStorePayOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStorePayOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storepayorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storepayorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storepayorder/importData`,formData);
              this.refreshShopStorePayOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStorePayOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStorePayOrderList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.count{
    font-size: 14px;
    margin-left: 10px;
    padding: 0 4px;
}
</style>